import React from 'react';
import { Button, ModalCloser, Notice, Separator, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import JsxRenderer from '../util/JsxRenderer';
const GravityFormSubmitResultNotice = (props) => {
    const { gravityFormStore, hasError, onClose, modalContent, translateStore: { translate }, propStateStore: { env } } = props;
    const handleResultModalClose = () => {
        gravityFormStore.toggleFormSubmitResultModal(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return (React.createElement(Text, null,
        React.createElement(Notice, { type: hasError ? 'error' : 'success', align: "center", direction: "vertical", attributes: { 'aria-live': 'polite' } },
            hasError ? (translate('general.error.message')) : (React.createElement(JsxRenderer, { jsx: modalContent, env: env, showErrorNotice: true, doNotScroll: true, translate: translate })),
            React.createElement(Separator, { spacing: 'small', color: 'invisible' }),
            React.createElement(ModalCloser, null,
                React.createElement(Button, { text: translate('modal.closeNotice'), variant: "secondary", onClick: handleResultModalClose })))));
};
export default inject('translateStore', 'propStateStore', 'gravityFormStore')(observer(GravityFormSubmitResultNotice));
//# sourceMappingURL=GravityFormSubmitResultNotice.js.map